import { render } from "./Metrics.vue?vue&type=template&id=005dd665&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=005dd665&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-005dd665"

export default script